<template>
  <form class="w-full overflow-hidden" @submit.prevent="onSubmitForm">
    <div class="vx-col w-full mb-3">
      <elsa-v-select
        htmlLabel="Тип прибора"
        :options="$store.getters['common/devices/types']"
        label="name"
        :reduce="item => item.id"
        :clearable="false"
        v-model="data.device_type"
        :danger="!!errors.device_type"
        :danger-text="errors.device_type"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <elsa-v-datepicker
        label="Дата начала"
        class="w-full"
        ref="dataStartDate"
        format="dd.MM.yyyy"
        v-model="data.start_date"
        :danger="!!errors.start_date"
        :danger-text="errors.start_date"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <elsa-v-datepicker
        label="Дата завершения"
        class="w-full"
        ref="dataEndDate"
        format="dd.MM.yyyy"
        v-model="data.end_date"
        :danger="!!errors.end_date"
        :danger-text="errors.end_date"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <vs-input
        label="Количество комнат"
        class="w-full"
        v-model="data.rooms"
        :danger="!!errors.rooms"
        :danger-text="errors.rooms"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <vs-input
        label="Количество проживающих"
        class="w-full"
        v-model="data.living"
        :danger="!!errors.living"
        :danger-text="errors.living"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <vs-input
        label="Значение"
        class="w-full"
        v-model="data.value"
        v-currency="10"
        :danger="!!errors.value"
        :danger-text="errors.value"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <vs-input
        label="Значение для электрической плиты"
        class="w-full"
        v-model="data.value_elect_oven"
        v-currency="10"
        :danger="!!errors.value_elect_oven"
        :danger-text="errors.value_elect_oven"
      />
    </div>
    <div class="vx-col w-full mb-3">
      <vs-input
        label="Значение для газовой плиты"
        class="w-full"
        v-model="data.value_gas_oven"
        v-currency="10"
        :danger="!!errors.value_gas_oven"
        :danger-text="errors.value_gas_oven"
      />
    </div>
    <div class="vx-col w-full flex justify-center">
      <vs-button
        id="regulation-submit-button"
        class="vs-con-loading__container"
        button="submit"
        type="filled"
        color="primary"
      >
        {{ regulation ? 'Сохранить' : 'Добавить' }}
      </vs-button>
    </div>
  </form>
</template>

<script>

import modalContext        from "@/mixins/modalContext";
import notifyHttpError     from "@/mixins/notifyHttpError";
import mergeCommonErrors   from "@/helpers/mergeCommonErrors";
import formatDate          from "@/client/helpers/formatDate";

const formFields = [
  'device_type',
  'start_date',
  'end_date',
  'rooms',
  'living',
  'value',
  'value_elect_oven',
  'value_gas_oven',
];
const emptyErrors = formFields.reduce(( dict, field ) => {
  dict[field] = null;
  return dict;
}, {});

export default {
  name:   "RegulationFormModal",
  mixins: [notifyHttpError, modalContext],
  props:  ['regulation', 'onSubmit'],
  data() {
    return {
      data:   this.getData(),
      errors: emptyErrors,
    };
  },
  computed: {},
  methods:  {
    getData() {
      const { regulation } = this;
      if (!regulation) return formFields.reduce(( dict, field ) => {
        dict[field] = null;
        return dict;
      }, {});
      const data = formFields.reduce(( dict, field ) => {
        dict[field] = regulation[field];
        return dict;
      }, {});
      data.start_date = new Date(data.start_date);
      data.end_date = new Date(data.end_date);
      return data;
    },

    onSubmitForm() {
      this.errors = emptyErrors;
      const request = this.onSubmit({
        ...this.data,
        start_date: formatDate(this.data.start_date, 'yyyy-MM-dd'),
        end_date:   formatDate(this.data.end_date, 'yyyy-MM-dd'),
      });
      if (request) {
        this.$vs.loading({ container: '#regulation-submit-button', scale: 0.45 });
        request.then(
          this.modalResolve,
          ( { response: { data } } ) => {
            this.errors = mergeCommonErrors(data.errors, formFields);
          },
        ).finally(() => {
          this.$vs.loading.close('#regulation-submit-button > .con-vs-loading');
        });
      }
    },
  },
  mounted() {

  },
  watch: {
  },
};
</script>

<style lang="scss" module>

</style>
